import React, {useCallback} from 'react';

type StepWrapperProps = {
  children: React.ReactNode;
  showVerticalLine?: boolean;
};

const StepWrapper: React.FC<StepWrapperProps> = ({children, showVerticalLine}) => {
  const [height, setHeight] = React.useState(0);

  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      if (node === null) {
        return;
      }
      setHeight(node.clientHeight);
    },
    [setHeight]
  );

  return (
    <div className="relative pb-4" ref={ref}>
      {/* step dot */}
      <div className="absolute left-[0px] top-1.5 h-3 w-3 rounded-full bg-slate-200" />
      {/* step vertical line */}
      {showVerticalLine && (
        <div className="absolute left-[5px] top-1.5 w-[2px] bg-slate-200" style={{height}} />
      )}
      <div className="ml-6 flex w-full items-center">{children}</div>
    </div>
  );
};

export default StepWrapper;
